import type { ModuleFederationRuntimePlugin } from '@module-federation/runtime';

const safeRemotePlugin = (): ModuleFederationRuntimePlugin => ({
  name: 'safe-remote-plugin',
  errorLoadRemote({ id, error }: { id: string; error: unknown }) {
    console.warn(`[MF] Remote "${id}" unavailable:`, (error as Error)?.message);
    return () => ({ default: () => null });
  }
});

export default safeRemotePlugin;
